import GoogleCloudDatabase from './data-storage';
import GoogleCloudStorageHandler from './storage';

export {GoogleCloudDatabase, GoogleCloudStorageHandler};

export default GoogleCloudDatabase;
